import {visualInspectionsActions, visualInspectionItemsActions, locationActions, useSelector} from "inbooma-api";
import VisualInspectionsSidebar from "./VisualInspectionsSidebar";
import SortNav from "../../../components/SortNav";
import Paginator from "../../../components/paginator";
import VisualInspectionsList from "./VisualInspectionsList";
import Loader from "../../../components/Loader";
import ItemView from "./ItemView";
import SubItemView from "./SubItemView";
import React, {useEffect, useState} from "react";
import {getAllUrlParams, Notification} from "../../../../utils";
import {getLocations} from "inbooma-api/store/locations/actions";
import {$, _} from "../../../../../vendor";
import {getContingents} from "inbooma-api/store/contingents/actions";
import {moment} from "../../../../../vendor";

const VisualInspectionsView = (props) => {
   const { params, name, dispatch, returnPath, rbac, isViewVisible,t, Biscuit, language} = props;
   const currentUrl = new URL(window.location.href)
   const searchParams = currentUrl.searchParams;
   const allUrlParams = getAllUrlParams(window.location.href);
   const allUrlParamsClone = {...allUrlParams};
   allUrlParams?.location_name !== undefined && delete allUrlParams.location_name;
   const _visualInspections = useSelector(state => state["visual_inspections_data"].getVisualInspections);
   const _visualInspection = useSelector(state => state["visual_inspections_data"].getVisualInspection);
   const _visualInspectionItem = useSelector(state => state["visual_inspection_items_data"].getVisualInspectionItem);
   const _locations = useSelector(state => state["locations_data"].locations);
   const _contingents = useSelector(state => state["contingents_data"].contingents);
   const [visualInspectionsPending, setVisualInspectionsPending] = useState(false);
   const [visualInspections, setVisualInspections] = useState([]);
   const [visualInspectionPending, setVisualInspectionPending] = useState(false);
   const [visualInspectionItemPending, setVisualInspectionItemPending] = useState(false);
   const [locationsPending, setLocationsPending] = useState(false);
   const [contingentsPending, setContingentsPending] = useState(false);
   const [initialized, setInitialized] = useState(false);
   const [filter,setFilter] = useState({
      find: 'full',
      ...allUrlParams
   });
   const [sort,setSort] = useState({
      sort: allUrlParamsClone?.sort !== undefined ? allUrlParamsClone.sort : "name",
      direction: allUrlParamsClone?.direction !== undefined ? allUrlParamsClone.direction : "asc"
   });
   const [_key,setKey] = useState(null);
   const paginationLimit = 100;
   const [pagination,setPagination] = useState({
      has_next_page: false,
      current_page: 1
   });
   const [resetFilter,setResetFilter] = useState(false);
   const _queryState = {
      timeStamp: 0,
      value: ""
   }
   function containsNumbers(str) {
      return /\d/.test(str);
   }

   useEffect(() => {
      if(!initialized){
         dispatch(visualInspectionsActions.getVisualInspections({
            token: Biscuit.get('token'),
            parameters: {
               headers: {
                  "Accept-Language": language
               }
            }
         }));
         setVisualInspectionsPending(true);

      if(params !== null){
         if(containsNumbers(params[0]))
            {
               dispatch(visualInspectionsActions.getVisualInspection({
                  token: Biscuit.get('token'),
                  id: params[0],
                  parameters: {
                     headers: {
                        "Accept-Language": language
                     }
                  }
               }));
               setVisualInspectionPending(true);
               if(typeof params[1] !== 'undefined' && params[1] === 'item' && typeof params[2] !== 'undefined' && containsNumbers(params[2])){
                  dispatch(visualInspectionItemsActions.getVisualInspectionItem(
                      {
                         token: Biscuit.get('token'),
                         id: params[2],
                         parameters: {
                            headers: {
                               "Accept-Language": language
                            }
                         }
                      }
                  ));
                  setVisualInspectionItemPending(true);
               }
            }
      }
         dispatch(getLocations({
            token: Biscuit.get('token'),
            filter: {
               'findForSelect': 1
            },
            parameters: {
               headers: {
                  'Accept-Language': language,
                  'Content-Language': language
               }
            }
         }));
         setLocationsPending(true);

         dispatch(getContingents({
            token: Biscuit.get('token'),
            parameters: {
               headers: {
                  'Accept-Language': language,
                  'Content-Language': language
               }
            }
         }));
         setContingentsPending(true);
      }
   }, []);

   useEffect(() => {
      if(!visualInspectionsPending || _visualInspections.success === ''){
         return;
      }
      setVisualInspectionsPending(false);
      if(_visualInspections.success === true){
         setVisualInspections(_visualInspections.data);
         setPagination({..._visualInspections.pagination});
      }
      if(!locationsPending && !contingentsPending && !visualInspectionPending && !visualInspectionItemPending){
         setInitialized(true);
      }
   }, [_visualInspections]);

   useEffect(() => {
      if(!visualInspectionPending || _visualInspection.success === ''){
         return;
      }
      setVisualInspectionPending(false);
      if(!locationsPending && !contingentsPending && !visualInspectionsPending && !visualInspectionItemPending){
         setInitialized(true);
      }
   }, [_visualInspection]);

   useEffect(() => {
      if(!visualInspectionItemPending || _visualInspectionItem.success === ''){
         return;
      }
      setVisualInspectionItemPending(false);
      if(!locationsPending && !contingentsPending && !visualInspectionsPending && !visualInspectionPending){
         setInitialized(true);
      }
   }, [_visualInspectionItem]);

   useEffect(() => {
      if(!locationsPending || _locations.success === ''){
         return;
      }
      setLocationsPending(false);
      if(!visualInspectionsPending && !contingentsPending && !visualInspectionPending && !visualInspectionItemPending){
         setInitialized(true);
      }
   }, [_locations]);

   useEffect(() => {
      if(!contingentsPending || _contingents.success === ''){
         return;
      }
      setContingentsPending(false);
      if(!locationsPending && !visualInspectionsPending && !visualInspectionPending && !visualInspectionItemPending){
         setInitialized(true);
      }
   }, [_contingents]);


   const loadNextPage = () => {

    //  if (!pagination.has_next_page) return;

      setVisualInspectionsPending(true);
      // request next page
      dispatch(visualInspectionsActions.getVisualInspections({
         token: Biscuit.get('token'),
         filter: {
            ...filter,
            page: pagination.current_page + 1,
            limit: pagination.limit
         },
         parameters: {
            headers: {
               "Accept-Language": language
            }
         }
      }));
   };

   const showNotification = (msgType, itemId, errorMsg ='') => {

      if (msgType === 'success') {
         new Notification({
            message : t('saved_${a}',{a:name},'capital')+' #'+ itemId,
            duration : 5000,
            type : 'success',
            closeable : true,
            icon : 'fi fi-check'
         });
      } else if (msgType === 'warning') {
         new Notification({
            message : errorMsg,
            duration : 5000,
            type : 'warning',
            closeable : true,
            icon : 'fi fi-x'
         });
      }
   };

   const onLocationQueryHandle = (query) => {

      // start dispatch of location query
      dispatch(locationActions.getLocations({
         token: Biscuit.get('token'),
         filter: {
            findForSelect: true,
            find: 'short',
            limit: 999,
            page: 1,
            q: query
         },
         parameters: {
            headers: {
               'Accept-Language': language,
               'Content-Language': language
            }
         }
      }));
      setLocationsPending(true);
   };

   const tabs =[{
      name: t('id',null,'capital'),
      smallWidth: 3,
      mediumWidth: 3,
      title: t('sort_by_${a}',{a:t('id')},'capital'),
      canSort: true,
      preselected: true,
      sort: {
         direction: sort.direction,
         data_inb_val: sort.sort
      }
   },{
      name: t('date',null,'capital'),
      smallWidth: 3,
      mediumWidth: 3,
      title: t('date',null,'capital'),
      canSort: true,
      sort: {
         direction: sort.direction,
         data_inb_val: sort.sort
      }
   }
   ];

   const onSortChangedHandle = (ev) => {

      const el = ev.currentTarget;
      const sortKey = el.getAttribute('data-inb-val'),
          direction = el.getAttribute('data-inb-direction'),
          isOppositeElement = (direction === null && el.classList.contains('is-active')),
          newDirection = (direction === 'desc' || isOppositeElement ? 'asc' : 'desc');

      if (sortKey) {
         let requestFilter;
         if(typeof filter.limit !== 'undefined') {
            requestFilter = {
               ...filter,
               sort: sortKey,
               direction: direction
            };
         } else {
            requestFilter = {
               ...filter,
               sort: sortKey,
               direction: direction,
               limit: paginationLimit,
               page: 1
            };
         }

         dispatch(getVisualInspections({
            token: Biscuit.get('token'),
            suffix: "",
            filter: requestFilter,
            parameters: {
               headers: {
                  'Accept-Language': language,
                  'Content-Language': language
               }
            }
         }));
         setVisualInspectionsPending(true);
         setSort({
            sort: sortKey,
            direction: direction
         });

         const activeSortTab = $('.is-active');
         _.each(activeSortTab, function(key){
            key["classList"].remove('is-active');
         });
         el.classList.add('is-active');
         el.setAttribute('data-inb-direction', (isOppositeElement ? 'desc' : newDirection));
      }
   };

   const filterChangedHandle = (filter,sorts = null) => {
      let requestFilter = {...filter};
      if(sorts === null){
         sorts = sort;
      } else {
         setSort(sorts);
      }
      requestFilter.sort = sorts.sort;
      requestFilter.direction = sorts.direction;
      if(typeof filter.limit !== 'undefined'){
         requestFilter.limit = filter.limit;
         if(typeof requestFilter.page !== 'undefined'){
            delete requestFilter.page;
         }
      } else {
         requestFilter.limit = paginationLimit;
         requestFilter.page = 1;
      }
      dispatch(visualInspectionsActions.getvisualInspections({
         token: Biscuit.get('token'),
         suffix: "",
         filter: requestFilter,
         parameters: {
            headers: {
               'Accept-Language': language,
               'Content-Language': language
            }
         }
      }));
      setVisualInspectionsPending(true);
      setFilter(filter);
   };

   return (
    <>
       <VisualInspectionsSidebar
           dispatch={dispatch}
           heading={name}
           locations={_locations?.data}
           contingents={_contingents?.data}
           onLocationQueryHandle={onLocationQueryHandle}
           rbac={rbac}
           filter={filter}
           setFilter={setFilter}
           resetFilter={resetFilter}
           setResetFilter={setResetFilter}
           initialized={(!locationsPending && !visualInspectionsPending && !contingentsPending)}
           sort={sort}
           setSort={setSort}
           t={t}
           name={name}
           Biscuit={Biscuit}
           moment={moment}
           /*summary={summary}
           summaryPending={summaryPending}*/
       />
       <div id='inb-c-main' className='columns'>
          <div className="sticky-container" style={{height:"59px"}}>
             <SortNav
                 tabs={tabs}
                 listStyle="tight"
                 handler={onSortChangedHandle}/>
          </div>
          {(initialized) && visualInspections.length > 0 && typeof pagination !== 'undefined' &&
              <Paginator
                  pagination={pagination}
                  itemsCountPerPage={paginationLimit}
                  pageRangeDisplayed={5}
                  onChange={loadNextPage}
              />}
          <div className="off-canvas-wrapper">
             {visualInspections.length > 0 && initialized && <VisualInspectionsList
                 visualInspections={visualInspections}
                 locations={_locations?.data}
                 contingents={_contingents?.data}
                 dispatch={dispatch}
                 filterChangedHandle={filterChangedHandle}
                 filter={filter}
                 setFilter={setFilter}
                 sort={sort}
                 setSort={setSort}
                 language={language}
                 _key={_key}
                 setKey={setKey}
                 params={params}
                 rbac={rbac}
                 Biscuit={Biscuit}
                 showNotification={showNotification}
                 moment={moment}
                 t={t}
             />}
             {(visualInspections.length < 1) &&
                 <>
                    <div
                        id="inb-app-collection-empty"
                        className="inb-announcement"
                        style={{ minHeight: "1150px" }}
                    >
                       <div className="inb-image-box">
                          <img alt="No Data" src={"assets/img/no_data.svg"}/>
                       </div>
                       <h3>
                          { t('app_msg_collection_empty') }
                       </h3>
                       <p>
                          { t('app_msg_collection_empty_body') }
                       </p>
                    </div>
                 </>
             }
             {initialized && visualInspections.length > 0 && typeof pagination !== 'undefined' &&
                 <Paginator
                     pagination={pagination}
                     itemsCountPerPage={paginationLimit}
                     pageRangeDisplayed={5}
                     onChange={loadNextPage}
                 />}
             {visualInspectionsPending && <Loader
                 mediumWidth={2}
                 smallWidth={4}
                 subLoaders={5}/>}
          </div>
       </div>
       {(params !== null && (params[0] === 'add' ||  (containsNumbers(params[0]) && typeof params[1] === 'undefined')) && initialized) &&
           <ItemView
               dispatch={dispatch}
               visualInspectionsActions={visualInspectionsActions}
               visualInspectionItemsActions={visualInspectionItemsActions}
               visualInspection={_visualInspection?.data}
               language={language}
               params={params}
               locations={_locations?.data}
               contingents={_contingents?.data}
               requestPath={returnPath}
               showNotification={showNotification}
               setFilter={setFilter}
               filter={filter}
               currentUrl={new URL(window.location.href)}
               t={t}
               moment={moment}
               Biscuit={Biscuit}
               rbac={rbac}
           />
       }
       {(params !== null && containsNumbers(params[0]) && typeof params[1] !== 'undefined' && params[1] === 'item' && (typeof params[2] !== 'undefined' && (params[2] === 'add' || containsNumbers(params[2]))) && initialized) &&
           <SubItemView
               dispatch={dispatch}
               visualInspectionsActions={visualInspectionsActions}
               visualInspectionItemsActions={visualInspectionItemsActions}
               visualInspection={_visualInspection.data}
               visualInspectionItem={_visualInspectionItem.data}
               language={language}
               params={params}
               locations={_locations?.data}
               contingents={_contingents?.data}
               requestPath={returnPath}
               showNotification={showNotification}
               setFilter={setFilter}
               filter={filter}
               currentUrl={new URL(window.location.href)}
               t={t}
               moment={moment}
               Biscuit={Biscuit}
               rbac={rbac}
           />
       }
    </>
);
}

export default VisualInspectionsView;